import * as React from "react";

const ShareIcon: React.FC = () => {
    return (
        <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x=".75" y="9.75" width="16.5" height="11.5" rx="2.75" stroke="#006AE3" strokeWidth="1.5" />
            <path fill="#fff" d="M4.5 7.5h9v4h-9z" />
            <path d="M9 14.5v-13m0 0L4.5 6M9 1.5 13.5 6" stroke="#006AE3" strokeWidth="1.5" strokeLinejoin="round" />
        </svg>
    );
};

export default React.memo(ShareIcon);
